/* eslint react/prop-types: 0 */
import { AivyContextProvider } from './aivy-context'
import { LanguageContextProvider } from './language-context'
import { NotificationContextProvider } from './notification-context'
import { PartnerContextProvider } from './partner-context'
import { PaymentContextProvider } from './payment-context'
import { ProductTourContextProvider } from './product-tour-context'
import { UserContextProvider } from './user-context'

// Bewusst nach den Contexts. Dialog und Watcher ziehen über
// features/pricing/hooks.js wieder diese Datei (Import-Zyklus), die Contexts
// sind dann schon geladen.
import PricingDialog from '../components/pricing/pricing-dialog'
import { PricingDialogProvider } from '../features/pricing/pricing-dialog-context'
import { PricingUsageWatcher } from '../features/pricing/use-usage-alerts'

export { useAivyContext } from './aivy-context'
export { useLanguageContext } from './language-context'
export { useNotificationContext } from './notification-context'
export { usePartnerContext } from './partner-context'
export { usePaymentContext } from './payment-context'
export { useProductTourContext } from './product-tour-context'
export { useUserContext } from './user-context'

export const GeneralContext = ({ language, children }) => {
  return (
    <NotificationContextProvider>
      <LanguageContextProvider language={language}>
        {children}
      </LanguageContextProvider>
    </NotificationContextProvider>
  )
}

export const DataContext = ({
  system,
  restartDashboard,
  cognitoUser,
  activeSpace,
  refetchActiveSpace,
  isAdmin,
  partner,
  refetchPartner,
  payments,
  employees,
  refetchEmployees,
  user,
  children
}) => {
  return (
    <ProductTourContextProvider>
      <AivyContextProvider system={system} restartDashboard={restartDashboard}>
        <UserContextProvider
          cognitoUser={cognitoUser}
          activeSpace={activeSpace}
          refetchActiveSpace={refetchActiveSpace}
          isAdmin={isAdmin}
          employees={employees}
          refetchEmployees={refetchEmployees}
          user={user}
        >
          <PartnerContextProvider
            partner={partner}
            refetchPartner={refetchPartner}
          >
            <PaymentContextProvider payments={payments}>
              {/* Sperr- und Limit-Dialog für alle Seiten, siehe
                  features/pricing/pricing-dialog-context.js. Daneben der
                  eine Auslöser der Nutzungs-Alerts nach #vertrieb, siehe
                  features/pricing/use-usage-alerts.js */}
              <PricingDialogProvider>
                {children}
                <PricingDialog />
                <PricingUsageWatcher />
              </PricingDialogProvider>
            </PaymentContextProvider>
          </PartnerContextProvider>
        </UserContextProvider>
      </AivyContextProvider>
    </ProductTourContextProvider>
  )
}
